module.exports = __webpack_public_path__ + "img/business.8b9850ea.webp";